let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("23EvE")).then(() => parcelRequire('eylG6'));